import myRequest from '@/services/myRequest';

export async function queryEmailNoticeList(params) {
  return myRequest('get', '/emailNotice/queryList', params);
}

export async function emailNoticeConfirm(params) {
  return myRequest('post', '/emailNotice/confirm', params);
}
